import React, { useState } from 'react';
import { getUserName } from '../ticketsList/ticketsListTable/utils/user';
import ticketService from 'modules/emergencies/ticketService';
import {
  ModalContainer,
  CloseButtonContainer,
  ModalBody,
  ModalFooter,
  ModalFormContainer,
  ModalHeader,
  ModalHeaderInnerContainer,
  ModalHeaderMainText,
  ModalHeaderSecondaryText,
} from './modalComponents';
import { FormButton } from '../ui/buttons/FormButton';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import SelectWithSearchInput from './SelectWithSearchInput';
import { PremiumInput } from '../ui/inputs/customInput';

const t = {
  error: 'No agents found, try again later',
  no_users: 'No agents found',
  field_label: 'Agent name',
  field_title: 'Assignation',
  confirm_agent: 'Assign',
  search_label: 'Search agent',
  back: 'Back',
};
export const AssignAgentModal = ({ ok, cancel, assignModalProps }) => {
  const { ticket = {}, usersOptions, isLoadingUsersToAssign, assignAgentError } = assignModalProps;
  const assigned = getUserName(ticket.assigned_to);
  const agentID = ticket.assigned_to?.id;
  const [selectedAgent, setSelectedAgent] = useState({
    value: agentID,
    label: assigned,
    display: assigned,
  });

  const workingAreas = ticket?.working_areas || [];
  const canBeAssignedToRegion = workingAreas.length >= 2;
  const [selectedWorkingArea, setSelectedWorkingArea] = useState(-1);
  const availableWorkingAreasOptions = workingAreas.map((area) => ({
    value: area.slug,
    label: area.slug,
  }));
  const workingAreasOptions = [
    { value: -1, label: 'Select a working area' },
    ...availableWorkingAreasOptions,
  ];

  const goBack = (e) => {
    e.preventDefault();
    cancel();
  };
  const formattedTicketId = ticketService.utils.getFormatedId(ticket.id);

  const isDisabled = selectedAgent.value === agentID && selectedWorkingArea === -1;
  return (
    <ModalContainer>
      <ModalBody>
        <ModalHeader>
          <ModalHeaderInnerContainer>
            <ModalHeaderSecondaryText>{t.field_title}</ModalHeaderSecondaryText>
            <ModalHeaderMainText>{`Ticket ID. ${formattedTicketId}`}</ModalHeaderMainText>
          </ModalHeaderInnerContainer>
        </ModalHeader>
        <ModalFormContainer>
          <SelectWithSearchInput
            onFieldChange={(selectedValue) => {
              const agent = usersOptions.filter((user) => user.value === selectedValue)[0];
              setSelectedAgent(agent);
            }}
            options={usersOptions}
            isLoadingOptions={isLoadingUsersToAssign}
            hasError={assignAgentError}
            value={selectedAgent.value}
            label={t.field_label}
            searchLabel={t.search_label}
            optionsEmptyMssg={t.no_users}
            isClereable={true}
            width="100%"
          />
          {canBeAssignedToRegion && (
            <PremiumInput
              label="Working area"
              width="100%"
              value={selectedWorkingArea}
              type={'select'}
              onChange={(option) => {
                setSelectedWorkingArea(option);
                return;
              }}
              availableOptions={workingAreasOptions}
            />
          )}
        </ModalFormContainer>
      </ModalBody>

      <ModalFooter>
        <FormButton variant="ghost" onClick={goBack}>
          {t.back}
        </FormButton>
        <FormButton
          isDisabled={isDisabled}
          onClick={() => {
            const result = {
              agent_id: selectedAgent.value,
              working_area: selectedWorkingArea,
            };
            !isDisabled && ok(result);
          }}
        >
          {t.confirm_agent}
        </FormButton>
      </ModalFooter>
      <CloseButtonContainer onClick={goBack}>
        <CloseIcon />
      </CloseButtonContainer>
    </ModalContainer>
  );
};
